// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uPNO","title":"Header_title__1uivP","side":"Header_side__2DQb8"};